import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Modal, Typography } from 'antd';

import ExtractContentEditor from '../tiptapEditor/components/ExtractContentEditor';
import useOptimizerEditorVersions from '../tiptapEditor/hooks/optimizer/useOptimizerEditorVersions';

import { selectDarkMode } from '../../../userBrowserSettings/store/browserSettings.selectors';

import CloseIcon from '../../../resources/icons/CloseIcon';
import { colorPalette } from '../../../resources/styles/colorPalette';

import { getThemeColorClass } from '../../../utils/helpers/themeHelpers';
import useMoveToOptimizerTab from '../../../utils/hooks/useMoveToOptimizerTab';

import './ImportAiContentModal.scss';

const { Link } = Typography;

const classes = {
    importModalWrapper: 'modal-wrapper',
    importAiContentWrapper: 'import-ai-content-wrapper',
    importAiContentActionsWrapper: 'imported-data-actions-wrapper d-flex justify-content-end',
    link: 'link-hover-highlight',
};

const defaultValues = {
    contentData: '',
    cleanupDebounceTime: 1000,
};

const ImportAiContentModal = ({
    isOpen,
    handleOpen,
    contentData = defaultValues.contentData,
    onSubmit = () => null,
}) => {
    const darkMode = useSelector(selectDarkMode);
    const darkModeClass = getThemeColorClass(darkMode);

    const { createNewEditorVersion } = useOptimizerEditorVersions();
    const [, setMoveToOptimizerTab] = useMoveToOptimizerTab(false);

    const [importedHtmlData, setImportedHtmlData] = useState(defaultValues.contentData);

    const closeModalIconColor = darkMode
        ? colorPalette.textColor.dark
        : colorPalette.textColor.light;

    const handleCancelImport = () => {
        handleOpen(false);

        setTimeout(() => {
            setImportedHtmlData(defaultValues.contentData);
            onSubmit();
        }, defaultValues.cleanupDebounceTime);
    };

    const handleImportIntoOptimizer = async () => {
        await createNewEditorVersion(importedHtmlData);
        setImportedHtmlData(defaultValues.contentData);
        onSubmit();
        handleOpen(false);
        setMoveToOptimizerTab(true);
    };

    return (
        <Modal
            centered
            forceRender
            title='Import AI Content'
            open={isOpen}
            onOk={handleOpen}
            onCancel={handleCancelImport}
            footer={null}
            closeIcon={<CloseIcon color={closeModalIconColor} />}
            wrapClassName={`${classes.importModalWrapper} ${darkModeClass}`}
        >
            <div className={`${classes.importAiContentWrapper} ${darkModeClass}`}>
                {contentData && (
                    <ExtractContentEditor
                        importedData={contentData}
                        setConvertedImportedHtmlData={setImportedHtmlData}
                    />
                )}
            </div>
            <div className={classes.importAiContentActionsWrapper}>
                <div className='d-flex align-items-center'>
                    <Link
                        underline
                        className={`${classes.link} ${darkModeClass}`}
                        onClick={handleCancelImport}
                    >
                        Delete
                    </Link>
                    <Link
                        underline
                        className={`${classes.link} ${darkModeClass}`}
                        onClick={handleImportIntoOptimizer}
                    >
                        Import into Optimizer
                    </Link>
                </div>
            </div>
        </Modal>
    );
};

export default ImportAiContentModal;
